import { Type, Dom, Text, Runtime, type } from 'main.core';
import { VSCore } from "vsbx.core";
import "./style.css";
let list = {};

class buttonProgress {
 constructor(node) {
  this.node = node;
  Dom.addClass(node, "link-d");
 }
 done() {
  let self = this;
  if (self.pNode) {
   self.pNode.remove();
   self.pNode = false;
   Dom.addClass(self.node, "ok");
   Dom.removeClass(self.node, 'disabled');
   self.node.removeAttribute('disabled');
   setTimeout(function () {
    Dom.removeClass(self.node, "ok");
    setTimeout(() => {
     self.iNode.remove();
     self.iNode = false;
    }, 500);
   }, 2000);
  }

 }
 start() {
  let self = this;
  self.pNode = Dom.create("SPAN", {
   props: {
    className: "c-loading spinner-grow",
   },
  });
  self.node.appendChild(self.pNode);
  self.iNode = BX.create("I", {
   props: {
    className: "i-ok",
   },
  });
  self.node.appendChild(self.iNode);
  Dom.addClass(self.node, 'disabled');
  self.node.setAttribute('disabled', 'disabled');
 }
}
class nodeProgress {
 constructor(node, type) {
  this.node = node;
  this.type = type;
 }
 done() {
  if (this.pNode) {
   this.pNode.remove();
   this.pNode = false;
  }
  Dom.removeClass(this.node, 'node-progress-loading');
 }
 start() {
  let self = this;
  self.pNode = Dom.create("SPAN", {
   props: {
    className: "progress-loading",
   },
   html: '<div><svg xmlns="http://www.w3.org/2000/svg" width="120" height="30" viewBox="0 0 120 30" fill="currentColor"><circle cx="15" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite" /><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" /></circle><circle cx="60" cy="15" r="9" fill-opacity="0.3"><animate attributeName="r" from="9" to="9" begin="0s" dur="0.8s" values="9;15;9" calcMode="linear" repeatCount="indefinite" /><animate attributeName="fill-opacity" from="0.5" to="0.5" begin="0s" dur="0.8s" values=".5;1;.5" calcMode="linear" repeatCount="indefinite" /></circle><circle cx="105" cy="15" r="15"><animate attributeName="r" from="15" to="15" begin="0s" dur="0.8s" values="15;9;15" calcMode="linear" repeatCount="indefinite" /><animate attributeName="fill-opacity" from="1" to="1" begin="0s" dur="0.8s" values="1;.5;1" calcMode="linear" repeatCount="indefinite" /></circle></svg></div>'
  });
  self.node.appendChild(self.pNode);
  Dom.addClass(self.node, 'node-progress-loading');
 }
}
export const VSManagerProgress = {
 doneAll: () => {
  for (let k in list) {
   let item = list[k];
   (new Promise(resolve => {
    const poll = () => {
     if (item.np) {
      resolve();
     } else {
      setTimeout(poll, 500);
     }
    }
    poll();
   })).then(() => {
    item.np.done();
   });
  }
 },
 startAll: () => {
  for (let k in list) {
   let item = list[k];
   (new Promise(resolve => {
    const poll = () => {
     if (item.np) {
      resolve();
     } else {
      setTimeout(poll, 500);
     }
    }
    poll();
   })).then(() => {
    item.np.start();
   });
  }
 },
 set: (node) => {
  if (!node) return;
  (new Promise(resolve => {
   if (node.__nprogress) return resolve();
   if (!type.isNotEmptyString(node.id)) {
    node.id = Text.getRandom() + "_wait";
   }
   switch (node.tagName) {
    case "A":
    case "BUTTON":
     node.__nprogress = new buttonProgress(node);
     break;
    default:
     let typeProgress = node.dataset.typeProgress;
     if (!type.isNotEmptyString(typeProgress)) {
      typeProgress = VSCore.getGlobalConfig()['GLOBAL_DEFAULT_PROGRESS_TYPE'];
     }
     if (typeProgress) {
      node.__nprogress = new nodeProgress(node, typeProgress);
     } else {
      Runtime.loadExtension("vsbx.nprogress").then((exports) => {
       node.__nprogress = window.NProgress();
       node.__nprogress.configure({
        parent: node,
        showSpinner: false,
       });
       list[node.id].np = node.__nprogress;
       resolve();
      });
     }
     break;
   }
   list[node.id] = {
    np: node.__nprogress,
    node: node,
   };
   if (node.__nprogress) resolve();
  })).then(() => { if (node.__nprogress) node.__nprogress.start(); });
 },
 get: (id) => {
  if (id) return list[id];
  return list;
 },
};

BX.showWait = function (node, msg) {
 node = BX(node) || document.body || document.documentElement;
 VSManagerProgress.set(node);
 return node;
};
BX.closeWait = function (node, msg) {
 if (node === false) return VSManagerProgress.doneAll();
 node = BX(node) || document.body || document.documentElement;
 (new Promise(resolve => {
  let maxPoll = 10, countPoll = 0;
  const poll = () => {
   if (!node.__nprogress) {
    if (countPoll >= maxPoll) {
     resolve();
    } else {
     setTimeout(poll, 500);
     countPoll++;
    }
   } else {
    resolve();
   }
  }
  poll()
 })).then(() => { if (node.__nprogress) node.__nprogress.done(); });
};

